var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34.651,
    height: 34.65,
    viewBox: "0 0 34.651 34.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140",
    "data-name": "Rectangle 140",
    width: 34.651,
    height: 34.65,
    fill: "#001233"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_191",
    "data-name": "Group 191",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_191-2",
    "data-name": "Group 191",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M17.325,0A17.325,17.325,0,1,0,34.651,17.326,17.291,17.291,0,0,0,17.325,0m-1.7,24.725c0,.445-.489.806-1.091.806H10.856c-.606,0-1.095-.36-1.095-.806V9.926c0-.445.489-.8,1.095-.8h3.671c.606,0,1.095.359,1.095.8Zm9.267,0c0,.445-.489.806-1.095.806H20.123c-.606,0-1.095-.36-1.095-.806V9.926c0-.445.489-.8,1.095-.8h3.671c.606,0,1.095.359,1.095.8Z",
    transform: "translate(0 0)",
    fill: "#001233"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.d09058cf8884cdc0e3e65d6e384e5539.svg";
export { ForwardRef as ReactComponent };